export default __webpack_public_path__ + "static/ovr-53a1c6561989974cbf1d4185bef5e3b3.png";